import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../assets/css/DownloadRequest.css";


export default function DownloadRequest() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const userId = sessionStorage.getItem("user_id");
  const [downloadRequest, setDownloadRequest] = useState([]); // fetched data
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  // ✅ Fetch data from API
  useEffect(() => {
    axios
      .post(`${BASE_URL}/access-control/api/list-request-download/`, {
        userId: userId,
      })
      .then((res) => {
        const validData = res.data.filter(
          (item) => item.status && item.status == "pending"
        );
        setDownloadRequest(validData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setLoading(false);
      });
  }, []);

  // ✅ Filter logic
  const filtered = useMemo(() => {
    return downloadRequest.filter((p) => {
      if (search && !`${p.request_sender_first_name}`.toLowerCase().includes(search.toLowerCase()))
        return false;
      return true;
    });
  }, [downloadRequest, search]);



  const itemsPerPage = 9; // cards per page
  const [currentPage, setCurrentPage] = useState(1);

  // total pages
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  // slice data for current page
  const paginatedData = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [filtered]);

  const resetFilters = () => {
    setSearch("");
  };

  const handleApprove = async (requestId) => {
    try {
      await axios.post(`${BASE_URL}/access-control/api/approved-download/`, {
        id: requestId,
        userId: userId,
      });

      // ✅ update UI instantly
      setDownloadRequest((prev) =>
        prev.map((item) =>
          item.id === requestId ? { ...item, status: "approved" } : item
        )
      );

    } catch (error) {
      console.error("Approve error:", error);
    }
  };

  return (
    <div className="home-page">
      {/* ===== Hero Section ===== */}
      {/* <section className="banner hero-banner">
        <div className="banner-overlay"></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12 left-section">
              <h1 className="heading">
                Discover Our Team’s <br /> Today
              </h1>
              
            </div>
            <div className="col-md-8 col-sm-8 right-section text-center">
              <input
                type="text"
                className="form-control search-input"
                placeholder="Search Collateral..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
      </section> */}
      <section className="data-sec">
        {/* ===== Cards Section ===== */}
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 ">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div id="download-request" className="row g-4">
                  {filtered.length === 0 ? (
                    <div className="col-12 text-center py-4">
                      <div className="alert alert-secondary">
                        No results found. Try changing filters.
                      </div>
                    </div>
                  ) : (
                    paginatedData.map((reqData, i) => (
                      <div
                        className="col-12 col-md-12 col-lg-12"
                        key={reqData.id || i}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card shadow-sm rounded-3">
                          <div className="card-body row">
                            <div className="col-10 col-md-10 col-lg-10">
                              <p className="card-meta">
                                {reqData.module} | {reqData.category}<br></br><br></br>
                                <b>{reqData.request_sender_first_name} {reqData.request_sender_last_name}</b> has sent requst to download
                                <b> {reqData.doc_name}</b>
                              </p>
                            </div>
                            <div className="col-2 col-md-2 col-lg-2">
                              <button
                                key={reqData.id}
                                className="btn downloadbtn"
                                onClick={() => handleApprove(reqData.id)}
                              >
                                {reqData.status === "approved" ? "Approved ✅" : "Approve Request"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))

                  )}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <nav>
                        <ul className="pagination">

                          {/* Previous */}
                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link pagination-action-btn"
                              onClick={() => setCurrentPage(prev => prev - 1)}
                            >
                              <i className="fa fa-arrow-circle-left"></i>
                            </button>
                          </li>

                          {/* Page Numbers */}
                          {[...Array(totalPages)].map((_, index) => (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link page-num"
                                onClick={() => setCurrentPage(index + 1)}
                              >
                                page {index + 1}
                              </button>
                            </li>
                          ))}

                          {/* Next */}
                          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link pagination-action-btn"
                              onClick={() => setCurrentPage(prev => prev + 1)}
                            >
                              <i className="fa fa-arrow-circle-right"></i>
                            </button>
                          </li>

                        </ul>
                      </nav>
                    </div>
                  )}

                </div>
              )}
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
